function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component/icon/ic_secure-Outline",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iconspace_Private_25px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.0255962,8.92372643 L7.0255962,7.09416502 C7.0255962,4.28374753 9.28120642,2 12.0704998,2 C14.8597931,2 17.1154034,4.28374753 17.1154034,7.09416502 L17.1154034,8.92372643 L18.5433301,8.92372643 C19.3549636,8.92372643 20,9.58961477 20,10.3957219 L20,20.5280045 C20,21.3341117 19.3549636,22 18.5433301,22 L5.45666991,22 C4.64503638,22 4,21.3341117 4,20.5280045 L4,10.3957219 C4,9.58961477 4.64503638,8.92372643 5.45666991,8.92372643 L7.0255962,8.92372643 Z M5.82278481,10.7419082 L5.82278481,20.1818182 L18.1772152,20.1818182 L18.1772152,10.7419082 L5.82278481,10.7419082 Z M15.2926186,8.89571322 L15.2926186,7.09416502 C15.2926186,5.28187729 13.8469568,3.81818182 12.0704998,3.81818182 C10.2940428,3.81818182 8.84838101,5.28187729 8.84838101,7.09416502 L8.84838101,8.89571322 L15.2926186,8.89571322 Z",
  id: "Shape",
  fill: "#92929D"
})));

function SvgIcSecureOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Component/icon/ic_secure Outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecureOutline);
export default __webpack_public_path__ + "static/media/ic_secure_outline.1ee2ff82.svg";
export { ForwardRef as ReactComponent };